module.exports = __webpack_public_path__ + "media/img/private-venue/location-0aeb634f6a857a3bcb276d50166306be.png";